import axios from "axios";
import { InitPage } from "../../../index";
import * as Toastr from "toastr";
import swal from "sweetalert";

declare let App: any;
declare let storeLocation: string;
declare let storeLocationId: string;
declare let tagMetadataUrl: string;
declare let transferCommitUrl: string;
declare let transferPath: string;

interface ITag {
  EPC: string;
  NumberOfPings: number;
  CurrentUnits: number;
  ItemNumber: string;
  AssetId: string;
  Description: string;
  Alu: string;
  Removed: boolean;
}

interface IEpcs {
  epcs: ITag[];
}

class EOSTransferReceivingSearch {
  epcReadsChannel: any;

  constructor() {
    this.init();
    const selectedReaderId  = localStorage.getItem("eosSelectedReaderId");
    if (selectedReaderId) {
      $("#reader_id").val(selectedReaderId);
      $("#reader_id").trigger("change");
    }

    $('.commit-icon').on('click', function(e) {
      e.preventDefault();
      // $('#commit-dialog1').modal('show');
    });

    let that = this;
    $('#reset-counter').on('click', function(e) {
      e.preventDefault();
      that.clearCounter();
    });
  }

  init() {
    $("#reader_id").on("change", function() {
      console.log("test");
      localStorage.setItem("eosSelectedReaderId", $("#reader_id").val().toString());
    });
    $("#startReader").on("click", this.startReader);
    $("#stopReader").on("click", this.stopReader);
    $("#commitTransfer").on("click", this.commitTransfer);
    $("#exportTransfer").on("click", this.exportCSV);

    // Connect ActionCable to receive reads
    this.epcReadsChannel = App.cable.subscriptions.create(
      // Connection configuration
      {
          channel: "ReadsChannel",
          roomId: `${storeLocation}`
      },
      // Pass in connection callbacks
      {
          connected() { /* Called when the subscription is ready for use on the server */ },
          disconnected() { /* Called when the subscription has been terminated by the server */ },
          received: (data: any) => this.onEpcsRead(data)
      }
    );
    console.log('INIT EOS Receiving');
  }

  clearCounter() {
    window.location.href = window.location.href + '&clear=true'
  }

  startReader() {
    const startUrl = $("#reader_id option:selected").data("start-url");
    if(startUrl)
    {
      axios.get(startUrl);
      console.log("Starting selected reader.");
      document.getElementById('readerRunningStatus').classList.remove('text-gray');
      document.getElementById('readerRunningStatus').classList.add('text-success');
      document.getElementById('startReader').classList.add('sn-display-none-important');
      document.getElementById('stopReader').classList.remove('sn-display-none-important');
    }
    else
      Toastr.error('Reader is not selected');
  }

  stopReader() {
    const startUrl = $("#reader_id option:selected").data("stop-url");
    axios.get(startUrl);
    console.log("Stopped selected reader.");
    document.getElementById('readerRunningStatus').classList.remove('text-success');
    document.getElementById('readerRunningStatus').classList.add('text-gray');
    document.getElementById('startReader').classList.remove('sn-display-none-important');
    document.getElementById('stopReader').classList.add('sn-display-none-important');
  }

  async commitTransfer() {
    if(!$(this).hasClass('disabled'))
    {
      const result = await swal(
        {
        title: 'Are you sure?',
        text: 'This action will commit reading data',
        icon: "warning",
        closeOnClickOutside: false,
        className: "sn-m-modal",
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true
          }
        },
        dangerMode: true
      }
      );
      if(result)
      {
        let params = { "transferID": $('#transferID').data('transfer-id'),
          "transferShippedDate": $('#transferShippedDate').data('value'),
          "transferFrom": $('#transferFrom').data('value'),
          "transferTo": $('#transferTo').data('value'),
          "expected": parseInt($('#expectedTagsCount').data('expected-count')),
          "read": parseInt($('#readTagsCount').text()),
          "diff": parseInt($('#tagDifferenceCount').text()),
          "payload": []
        };
        $('.readLineItems').each((index, element) => {
          params["payload"].push({
            "itemID": $(element).data('ls-id'),
            "itemNumber": $(element).data('systemsku'),
            "itemName": $(element).data('name'),
            "receivedEPCs": $(element).data('epcs'),
            "receivedCount": $(element).data('epcs').length,
            "sentCount": $(element).data('sent'),
            "transferID": $('#transferID').data('transfer-id')
          })
        });
        console.log(params);
        const token = $("[name=authenticity_token]").val();
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        const resp = await axios.post(transferCommitUrl, { payload: params });
        console.log(resp.data);
        if(resp.data.status == 'ok') {
          window.location.pathname = transferPath;
        } else {
          Toastr.error(resp.data.message);
        }
      }
    }
  }

  buildParams() {

  }

  exportCSV() {
    let rows = [["item_number", "item_description", "expected", "read", "difference", "status"]]
    let transferId = $('#transferItemDetails').data('transfer-id');
    let type = $('#transferItemDetails').data('type');
    $('.readLineItems').each((index, element) => {
      console.log(element);
      let itemNumber = $(element).data('systemsku');
      rows.push([$('#'+itemNumber+'-itemNumber').text(),
                 $('#'+itemNumber+'-itemDescription').text(),
                 $('#'+itemNumber+'-itemSentCount').text(),
                 $('#'+itemNumber+'-itemReceivedCount').text(),
                 $('#'+itemNumber+'-itemReceivedDiff').text(),
                 $('#'+itemNumber+'-itemStatus').text().trim()])
    });
    console.log(rows);
    let csvContent = "data:text/csv;charset=utf-8,";

    rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);

    link.setAttribute("download", "eos_"+type+"_receiving_"+transferId+".csv");
    document.body.appendChild(link); // Required for FF

    link.click();
  }

  addNonExistingItem(element) {
    console.log(element);
    let newLineTemplate = `
      <tr class="text-center readLineItems" id="${element.item_number}-item" data-ls-id="0" data-epcs=["${element.epc}"] data-sent="0" data-systemSku="${element.item_number}" data-name="${element.item_name}">
          <td> ${$(".readLineItems").length + 1}</td>
          <td id="${element.item_number}-itemNumber" > ${element.item_number} </td>
          <td style="text-align: left !important" id="${element.item_number}-itemDescription" >${element.item_name}</td>
          <td id="${element.item_number}-itemSentCount" >0</td>
          <td id="${element.item_number}-itemReceivedCount">1</td>
          <td id="${element.item_number}-itemReceivedDiff">1</td>
          <td class="sn-status" id="${element.item_number}-itemStatus">
                  <div class="table-status danger-status"> WRONG ITEM </div>
          </td>
      </tr>
      `
    $("#transferItemDetails").append(newLineTemplate);
  }

  async onEpcsRead(data: IEpcs) {
    console.log(data);
    const token = $("[name=authenticity_token]").val();
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    const itemsResp = await axios.post(`${tagMetadataUrl}?store_code=${storeLocationId}`, data.epcs.map((t: ITag) => t.EPC));
    console.log(itemsResp.data);
    let totalRead = 0;
    itemsResp.data.forEach(element => {
      let mode = $('input[name="reader"]:checked').val();
      if(mode == 'remove') {
        this.removeEPC(element);
      } else {
        this.addEpc(element);
      }
    });
    this.totalRead();
  }

  totalRead() {
    let total = 0;
    $('.readLineItems').each((index, element) => {
      total += $(element).data('epcs').length;
    });
    $('#readTagsCount').text(total);
    if(total == 0)
    {
      $('#commitTransfer').addClass('disabled');
    }
    else
    {
      $('#commitTransfer').removeClass('disabled');
    }
    let expected = parseInt($('#expectedTagsCount').data('expected-count'));
    $('#tagDifferenceCount').text(total - expected);
    return total;
  }

  removeEPC(element) {
    console.log(element);
    console.log(element.epc);
    let epcs = $('#'+element.item_number+'-item').data('epcs');
    if (epcs !== undefined) {
      console.log(epcs);
      epcs = this.uniqueFilter(this.removeElement(epcs, element.epc));
      $('#'+element.item_number+'-item').data('epcs', epcs);
      console.log(epcs);
      $('#'+element.item_number+'-itemReceivedCount').text(epcs.length);
      let sent_count =  parseInt($('#'+element.item_number+'-item').data('sent'));
      $('#'+ element.item_number + '-itemReceivedDiff').text(epcs.length - sent_count);
      this.checkStatus(element.item_number);
      return 1
    } else {
      console.log("Item not present");
      return 0
    }
  }

  uniqueFilter(array) {
    return array.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  }

  addEpc(element) {
    console.log(element);
    console.log(element.epc);
    let epcs = $('#'+element.item_number+'-item').data('epcs');
    if (epcs !== undefined) {
      console.log(epcs);
      epcs.push(element.epc);
      epcs = this.uniqueFilter(epcs)
      $('#'+element.item_number+'-item').data('epcs', epcs);
      console.log(epcs);
      $('#'+element.item_number+'-itemReceivedCount').text(epcs.length);
      let sent_count =  parseInt($('#'+element.item_number+'-item').data('sent'));
      $('#'+ element.item_number + '-itemReceivedDiff').text(epcs.length - sent_count)
      this.checkStatus(element.item_number);
      return 1
    } else {
      this.addNonExistingItem(element);
      return 0
    }
  }

  checkStatus(item_number: string) {
    let diff = parseInt($("#"+item_number+"-itemReceivedDiff").text().toString());
    let expectedItem = parseInt($("#"+item_number+"-item").data('sent'));
    if (expectedItem == 0) {
      $("#"+item_number+"-itemStatus").html(`<div class="table-status danger-status"> WRONG ITEM </div>`)
    }
    else if( diff == 0) {
      $("#"+item_number+"-itemStatus").html(`<div class="table-status success-status"> MATCHED </div>`);
    }
    else if(diff > 0)
    {
      $("#"+item_number+"-itemStatus").html(`<div class="table-status warning-status"> QTY IS MORE </div>`);
    }
    else if(diff < 0)
    {
      $("#"+item_number+"-itemStatus").html(`<div class="table-status low-warning-status"> QTY IS LESS </div>`);
    }

  }

  removeElement(array, element) {
    let index = array.indexOf(element);
    array.splice(index, 1)
    return array
  }
}

export function LoadPage() {
  InitPage("receiving search", () => {
    new EOSTransferReceivingSearch();
  });
}
